__turbopack_context__.v({
  "BUTTON_BLACK": "Link-module__iWxDaq__BUTTON_BLACK" + " " + "Link-module__iWxDaq__buttonBase",
  "BUTTON_BLUE": "Link-module__iWxDaq__BUTTON_BLUE" + " " + "Link-module__iWxDaq__buttonBase",
  "BUTTON_BLUE_LIGHT": "Link-module__iWxDaq__BUTTON_BLUE_LIGHT" + " " + "Link-module__iWxDaq__buttonBase",
  "BUTTON_GRAY": "Link-module__iWxDaq__BUTTON_GRAY" + " " + "Link-module__iWxDaq__buttonBase",
  "buttonBase": "Link-module__iWxDaq__buttonBase",
});
